import React from 'react';

/**
 * Co Crate Studio brand mark — uses the official logo PNG (with transparent bg).
 * Renders the standalone logo only (no "by rg." appendage).
 */
export default function BrandMark({ tone = 'dark', size = 'md', className = '' }) {
  const isLight = tone === 'light';
  const logoSrc = isLight ? '/brand/co-crate-white.png' : '/brand/co-crate-green.png';

  const scale = {
    sm: 'h-5 md:h-6',
    md: 'h-6 md:h-7',
    lg: 'h-7 md:h-8',
  }[size];

  return (
    <div
      className={`inline-flex items-center ${className}`}
      aria-label="Co Crate Studio"
    >
      <img
        src={logoSrc}
        alt="Co Crate Studio"
        className={`${scale} w-auto select-none`}
        draggable="false"
      />
    </div>
  );
}
